import { mediaQueries } from '@centivo/react-components'
import styled from 'styled-components'

export const StyledInstitutionProfilePage = styled.div`
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 1.25rem 1.5rem 1.5rem;

  && * {
    font-family: 'AnekGujarati', sans-serif;
  }

  .back-button {
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: transparent;
    border: none;
    cursor: pointer;
    margin: 1rem 0;
    height: 2rem;
    width: fit-content;

    svg + * {
      margin-left: 0.5rem;
    }
  }

  .mapboxgl-map {
    .icon-centivo--rebrand-active-map-pin {
      height: 1.5rem;
    }
  }

  @media ${mediaQueries.desktop} {
    padding: 0 2.5rem;
  }
`

export const StyledInstitutionFallback = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  padding: 3rem 1.5rem;
  min-height: 60vh;

  h1 {
    margin: 0;
    font-family: 'roc-grotesk', 'Space Grotesk', system-ui, sans-serif;
  }

  p {
    margin: 0;
    max-width: 35rem;
    text-align: center;
    color: #707a89;
    font-family: 'roc-grotesk', 'Space Grotesk', system-ui, sans-serif;
  }
`
